import {
  Container,
  Header,
  SpaceBetween,
  Input,
  FormField,
  TextContent,
  ColumnLayout,
} from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import { CONSTRAINT_TEXT, IErrMsg, LABELS } from "./constants";
import InfoField from "../UI/InfoField";
import {
  BankAccountsUpdateRequest,
  ReferenceGroupForBankAccount,
} from "../../features/api-interfaces";
import { COMMON_LABELS } from "../default-constants";
import { validEmail } from "./validation";

interface IReferenceGroup {
  referenceGroup?: ReferenceGroupForBankAccount;
  isModalOpen: boolean;
  isUpdate: boolean;
  request: BankAccountsUpdateRequest;
  setRequest: Dispatch<SetStateAction<BankAccountsUpdateRequest>>;
  errMsg: IErrMsg;
  setErrMsg: Dispatch<SetStateAction<IErrMsg>>;
}

/**
 * 入金口座情報照会・更新 参照グループ
 */
export const ReferenceGroup = (props: IReferenceGroup) => {
  const {
    referenceGroup,
    isModalOpen,
    isUpdate,
    request,
    setRequest,
    errMsg,
    setErrMsg,
  } = props;

  /**
   * HD事業者の参照グループIDを表示する
   */
  const displayHdReferenceGroupId = () => (
    <>
      {referenceGroup?.hdReferenceGroupId && (
        <TextContent>
          <SpaceBetween direction={"horizontal"} size={"xxxs"}>
            <p>{COMMON_LABELS.LEFT_PARENTHESIS + "　"}</p>
            <h4>{LABELS.HD_REFERENCE_GROUPS_ID}</h4>
            <p>
              {COMMON_LABELS.COLON +
                referenceGroup?.hdReferenceGroupId +
                "　" +
                COMMON_LABELS.RIGHT_PARENTHESIS}
            </p>
          </SpaceBetween>
        </TextContent>
      )}
    </>
  );

  /**
   * 精算額通知先メールアドレスの入力ハンドラ.
   * @param {string} inputValue 入力値
   */
  const emailOnChange = (inputValue: string) => {
    setRequest({ ...request, notificationEmail: inputValue });
    setErrMsg({ ...errMsg, notificationEmail: validEmail(inputValue) });
  };

  return (
    <Container
      header={<Header variant={"h2"}>{LABELS.REFERENCE_GROUP_TITLE}</Header>}
    >
      <>
        {isUpdate ? (
          <>
            <SpaceBetween direction={"horizontal"} size={"xxl"}>
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"h4"}
                values={[
                  LABELS.REFERENCE_GROUPS_ID,
                  LABELS.REFERENCE_GROUPS_NAME,
                ]}
              />
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"p"}
                values={[
                  referenceGroup?.referenceGroupId,
                  referenceGroup?.referenceGroupName,
                ]}
              />
              {displayHdReferenceGroupId()}
            </SpaceBetween>
            <SpaceBetween direction={"horizontal"} size={"xxl"}>
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"h4"}
                values={[LABELS.NOTIFICATION_EMAIL]}
              />
              <FormField
                errorText={errMsg.notificationEmail}
                constraintText={`${CONSTRAINT_TEXT.NOTIFICATION_EMAIL}　　　　　　　　　　　　　　　　　　　　　　　`}
              >
                <Input
                  value={request.notificationEmail}
                  onChange={({ detail: { value } }) => emailOnChange(value)}
                />
              </FormField>
            </SpaceBetween>
          </>
        ) : (
          <>
            {isModalOpen ? (
              <SpaceBetween direction={"vertical"} size={"xxs"}>
                <SpaceBetween direction={"horizontal"} size={"xxl"}>
                  <ColumnLayout columns={4}>
                    <InfoField
                      direction={"vertical"}
                      size={"xxs"}
                      tag={"h4"}
                      values={[LABELS.REFERENCE_GROUPS_ID]}
                    />
                  </ColumnLayout>
                  <ColumnLayout columns={4}>
                    <InfoField
                      direction={"vertical"}
                      size={"xxs"}
                      tag={"p"}
                      values={[referenceGroup?.referenceGroupId]}
                    />
                  </ColumnLayout>
                  {displayHdReferenceGroupId()}
                </SpaceBetween>
                <SpaceBetween direction={"horizontal"} size={"xxl"}>
                  <ColumnLayout columns={4}>
                    <InfoField
                      direction={"vertical"}
                      size={"xxs"}
                      tag={"h4"}
                      values={[
                        LABELS.REFERENCE_GROUPS_NAME,
                        LABELS.NOTIFICATION_EMAIL,
                      ]}
                    />
                  </ColumnLayout>
                  <ColumnLayout columns={4}>
                    <InfoField
                      direction={"vertical"}
                      size={"xxs"}
                      tag={"p"}
                      values={[
                        referenceGroup?.referenceGroupName,
                        referenceGroup?.notificationEmail,
                      ]}
                    />
                  </ColumnLayout>
                </SpaceBetween>
              </SpaceBetween>
            ) : (
              <SpaceBetween direction={"horizontal"} size={"xxl"}>
                <InfoField
                  direction={"vertical"}
                  size={"xxs"}
                  tag={"h4"}
                  values={[
                    LABELS.REFERENCE_GROUPS_ID,
                    LABELS.REFERENCE_GROUPS_NAME,
                    LABELS.NOTIFICATION_EMAIL,
                  ]}
                />
                <InfoField
                  direction={"vertical"}
                  size={"xxs"}
                  tag={"p"}
                  values={[
                    referenceGroup?.referenceGroupId,
                    referenceGroup?.referenceGroupName,
                    referenceGroup?.beforeNotificationEmail,
                  ]}
                />
                {displayHdReferenceGroupId()}
              </SpaceBetween>
            )}
          </>
        )}
      </>
    </Container>
  );
};
